module.exports = __webpack_public_path__ + "static/img/nova-carteira.030f2f86.svg";